export default "__VITE_ASSET__32c960be__"